import { Text } from "@sembark-travel/ui-base"
import { type TTypingUser } from "./useThreadTyping"

/**
 * The "X is typing…" hint shown above the composer. New inbound threads seed
 * several subscribers, so this signals when another of them is already replying.
 * Renders nothing when no one else is typing.
 */
export function WhatsAppTypingIndicator({
	typingUsers,
}: {
	typingUsers: Array<TTypingUser>
}) {
	const label = typingLabel(typingUsers)
	if (!label) {
		return null
	}
	return (
		<Text fontSize="xs" color="muted">
			{label}
		</Text>
	)
}

function typingLabel(users: Array<TTypingUser>): string | null {
	switch (users.length) {
		case 0:
			return null
		case 1:
			return `${users[0].name} is typing…`
		case 2:
			return `${users[0].name} and ${users[1].name} are typing…`
		default:
			return `${users.length} people typing…`
	}
}
